<template lang="pug">
  v-footer.border-radius-bottom(
    ref="containerRef"
    :app="!!isActive"
    :fixed="!isActive"
    bottom
    style="top: initial; margin-top: -100px; transition: .2222s ease transform;"
    :height="height"
    :style="isActive ? undefined : `transform: translate3d(0, ${height}, 0)`")
    v-row(v-if="bottomAction")
      v-col(v-if="bottomAction.textInput")
        v-textarea(
          v-model="bottomAction.textInput.model"
          style="max-height: 94px; overflow-y: auto;"
          :rows="1"
          :autofocus="bottomAction.textInput.autofocus"
          background-color="transparent"
          solo
          flat
          single-line
          auto-grow
          hide-details
          :placeholder="bottomAction.textInput.label")
      v-col.shrink.d-flex.align-center(v-if="bottomAction.textInput")
        v-scale-transition(
          mode="out-in"
          origin="center center 0")
          template(v-if="bottomAction.textInput.action && bottomAction.textInput.model")
            utility-action-state(
              :action="bottomAction.textInput.action.onClick"
              :payload="{ content: bottomAction.textInput.model }")
              template(#default="{ loading, trigger }")
                v-btn(
                  @click="trigger"
                  color="primary"
                  :loading="loading"
                  :disabled="$get(bottomAction.textInput.model, `length`) >= bottomAction.textInput.max"
                  icon
                  left)
                  v-icon {{ bottomAction.textInput.action.icon }}
      v-col(
        v-if="bottomAction.side"
        style="font-weight: bold")
        template(v-if="typeof bottomAction.side === 'object'")
          div {{ bottomAction.side.title }}
          div.subtitle-1 {{ bottomAction.side.subtitle }}
        template(v-else) {{ bottomAction.side }}
      v-col.text-right.align-center.d-flex(
        v-if="bottomAction.action"
        :class="bottomAction.side ? `shrink` : null")
        v-spacer(v-if="bottomAction.side")
        utility-action-state(:action="bottomAction.action.onClick")
          template(#default="{ loading, trigger }")
            v-btn(
              :block="!bottomAction.side"
              large
              color="primary"
              :disabled="loading || bottomAction.action.isLoading"
              :loading="loading || bottomAction.action.isLoading"
              @click='trigger') {{ bottomAction.action.label }}
        v-spacer(v-if="bottomAction.center")
</template>

<script>
import { state } from '..'
import { toRefs, computed, ref, watch, onMounted, reactive } from '@vue/composition-api'
import UtilityActionState from '@iez/components/utility/action-state/'
import { VAppBar, VToolbarTitle, VSpacer, VBtn } from 'vuetify/lib'
import waitForActively from '@iez/lib/wait-for-actively/'
import { vuetify } from '@iez/core'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { state as bottomActionState } from '../../bottom-action/'
import { state as blockingMenuState } from '../../blocking-menu/'

gsap.registerPlugin(ScrollToPlugin)

export default {
  components: {
    VAppBar, VToolbarTitle, VSpacer, VBtn,
    UtilityActionState
  },

  setup () {
    const height = computed(() => state.bottomAction?.textInput ? 'auto' : `72px`)
    const containerRef = ref(null)
    const isActive = computed(
      () =>
        !!state.bottomAction &&
        !blockingMenuState.blockingMenu
    )

    onMounted(() => {
      watch(
        () => height.value,
        height => {
          if (containerRef.value?.$el?.style) {
            containerRef.value.$el.style.height = height
          }
          if (containerRef.value?.$el?.children?.[0]?.style) {
            containerRef.value.$el.children[0].style.height = height
          }
        }
      )
      watch(
        () => state.bottomAction,
        async () => {
          const { bottomAction } = state
          const height = await waitForActively({
            predicate: () => containerRef.value.$el.offsetHeight
          })
          if (
            document
              .activeElement
              .getBoundingClientRect()
              .y - height < vuetify.framework.application.top
          ) {
            return
          }
          if (bottomAction) {
            gsap.to(
              window, {
                duration: .3,
                scrollTo: window.scrollY + height
              }
            )
          } else {
            gsap.to(
              window, {
                duration: .3,
                scrollTo: window.scrollY - height
              }
            )
          }
        }
      )
    })


    return {
      ...toRefs(state),
      containerRef,
      height,
      isActive
    }
  }
}
</script>
